export const FETCH = "order.notifications.FETCH";
export const FETCH_FAILED = "order.notifications.FETCH_FAILED";
export const FETCH_OK = "order.notifications.FETCH_OK";

export const REMOVE = "order.notifications.REMOVE";
export const SET_STATUS = "order.notifications.SET_STATUS";
